(function(){"use strict";var e;try{if(typeof document<"u"){var a=document.createElement("style");a.nonce=(e=document.head.querySelector("meta[property=csp-nonce]"))==null?void 0:e.content,a.appendChild(document.createTextNode(".cursor-none[data-v-605dafc1]{cursor:none}.fit-content[data-v-605dafc1]{width:fit-content}.own-width[data-v-605dafc1]{width:100%;height:100%}.img-zoomer-box[data-v-605dafc1]{position:relative}.original-img[data-v-605dafc1]{width:100%;height:100%}.img-zoomer-box:hover .magnified-img[data-v-605dafc1],.img-zoomer-box:active .magnified-img[data-v-605dafc1]{opacity:1}.magnified-img[data-v-605dafc1]{width:var(--2188a7c6);height:var(--2188a7c6);background:var(--77b8e7a3);background-size:var(--fafa3542);background-position-x:var(--208c54d8);background-position-y:var(--208b6c1a);border-radius:var(--7238cf73);border:var(--55ff86e5);z-index:var(--82691aec);box-shadow:var(--76858f79);transition:var(--c8e656da);left:var(--0560b7c1);top:var(--b2d520d2);pointer-events:none;position:absolute;max-width:var(--60d3bde2);opacity:0;display:block}")),document.head.appendChild(a)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { defineComponent as Z, useCssVars as E, watch as O, ref as a, onMounted as T, computed as t, openBlock as x, createElementBlock as B, normalizeClass as y, createElementVNode as D, createCommentVNode as j } from "vue";
const q = ["src", "alt"], A = /* @__PURE__ */ Z({
  __name: "VImageMagnifier",
  props: {
    src: {},
    imgClass: {},
    zoomSize: { default: 100 },
    zoomFactor: { default: 1.8 },
    backgroundColor: { default: "#ffff" },
    cursorNone: { type: Boolean, default: !0 },
    magnifiedBorderRadius: { default: 50 },
    magnifiedBorderSize: { default: 4 },
    magnifiedBorderColor: { default: "#ffff" },
    magnifiedBorderStyle: { default: "solid" },
    zIndex: { default: 99 },
    boxShadow: { default: "0 5px 10px -2px rgba(0, 0, 0, 0.5)" },
    magnifiedTransition: { default: "opacity 0.2s" },
    altImage: {},
    deactivate: { type: Boolean, default: !1 },
    fitContent: { type: Boolean, default: !0 }
  },
  emits: ["loaded"],
  setup(i, { emit: s }) {
    E((o) => ({
      "2188a7c6": I.value,
      "77b8e7a3": _.value,
      fafa3542: P.value,
      "208c54d8": M.value,
      "208b6c1a": X.value,
      "7238cf73": w.value,
      "55ff86e5": V.value,
      "82691aec": o.zIndex,
      "76858f79": o.boxShadow,
      c8e656da: o.magnifiedTransition,
      "0560b7c1": Y.value,
      b2d520d2: N.value,
      "60d3bde2": F.value
    }));
    const e = i, u = s;
    O(() => e.deactivate, () => {
      b && (r.value = e.deactivate);
    });
    const c = a(), $ = a(), l = a(), f = a(0), g = a(0), v = a(0), p = a(0), C = a(0), z = a(0), b = a(!1), r = a(e.deactivate);
    T(() => {
      h();
    });
    const k = () => {
      h(), u("loaded"), b.value = !0, e.deactivate || (r.value = !1);
    }, h = () => {
      f.value = l.value.naturalWidth, g.value = l.value.naturalHeight;
    }, S = (o) => {
      if (!r.value) {
        const n = c.value.getBoundingClientRect(), R = l.value.naturalWidth / n.width * e.zoomFactor, W = l.value.naturalHeight / n.height * e.zoomFactor, H = (o.clientX - n.left) * R - d.value, L = (o.clientY - n.top) * W - d.value;
        v.value = -H, p.value = -L, C.value = o.clientX - n.left - d.value, z.value = o.clientY - n.top - d.value;
      }
    }, d = t(() => e.zoomSize / 2), I = t(() => `${e.zoomSize}px`), P = t(
      () => `${f.value * e.zoomFactor}px ${g.value * e.zoomFactor}px`
    ), _ = t(() => `url("${e.src}") no-repeat ${e.backgroundColor}`), w = t(() => `${e.magnifiedBorderRadius}%`), V = t(
      () => `${e.magnifiedBorderSize}px ${e.magnifiedBorderStyle} ${e.magnifiedBorderColor}`
    ), F = t(() => `${f.value}px`), M = t(() => `${v.value}px`), X = t(() => `${p.value}px`), Y = t(() => `${C.value}px`), N = t(() => `${z.value}px`);
    return (o, n) => (x(), B("div", {
      class: y(["img-zoomer-box", { "cursor-none": o.cursorNone && !r.value, "fit-content": o.fitContent, "own-width": !o.fitContent }]),
      ref_key: "imgZoomerBox",
      ref: c,
      onMousemove: S
    }, [
      D("img", {
        src: o.src,
        class: y(["original-img", { imgClass: o.imgClass }]),
        alt: o.altImage,
        ref_key: "original",
        ref: l,
        onLoad: k
      }, null, 42, q),
      r.value ? j("", !0) : (x(), B("div", {
        key: 0,
        class: "magnified-img",
        ref_key: "magnified",
        ref: $
      }, null, 512))
    ], 34));
  }
}), G = (i, s) => {
  const e = i.__vccOpts || i;
  for (const [u, c] of s)
    e[u] = c;
  return e;
}, m = /* @__PURE__ */ G(A, [["__scopeId", "data-v-605dafc1"]]), K = {
  install: (i, s) => {
    i.component("VImageMagnifier", m);
    for (let e in s)
      m.props.hasOwnProperty(e) && (m.props[e].default = s[e]);
  }
};
export {
  K as default
};
